export default __webpack_public_path__ + "static/media/HomeBackground.598abb78.jpg";